module.exports = __webpack_public_path__ + "static/media/casino_banner.76ded86d.gif";